export const createIndexArray = (size: number) => Array.from({ length: size }, (_, index) => index);
